<template>
    <div class="frame-blank-layout">
        <slot/>
    </div>
</template>

<script>
export default {
    name: 'blank-layout',
    props: {
        space: {
            type: [Number, String],
            default: 12
        }
    }
}
</script>

<style lang="less">
.frame-blank-layout {
    overflow: auto;
    height: 100%;
    padding: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/framework/layout/blank-layout.vue